// extracted by mini-css-extract-plugin
export default {"data_table":"updates_data_table__ffqVL","action":"updates_action__IwFbc"};